export default __webpack_public_path__ + "static/media/Details-02.f65517a8.jpg";